import React, { useState } from 'react';
import moment from 'moment';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';

import {
  BackArrowSmallIcon,
  ForwardArrowSmallIcon,
  TriangleDownIcon,
  ChevronActiveIcon,
  ChevronDisabledIcon,
} from '../../assets';

import classes from '../../styles/pages/calendar/_calendar.module.scss';
import { CalendarProps } from './models/calendarModels';
import { monthsList } from '../../config/dateConfig';
import CalendarItem from './components/CalendarItem';
import MonthList from './components/MonthList';

const Calendar: React.FC<CalendarProps> = ({
  selectedMonth,
  selectedYear,
  setSelectedYear,
  setSelectedMonth,
  setNextYear,
  setNextMonth,
  isCurrentMonthLoading,
  calendlyEventsData,
}) => {
  moment.updateLocale('en', {
    week: {
      dow: 1,
    },
  });

  const [showCurrentMonthList, setShowCurrentMonthList] = useState(false);
  const [showNextMonthList, setShowNextMonthList] = useState(false);
  const currentYear = moment().year();
  const currentMonth = moment().month();

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const openCurrentMonthList = () => {
    setShowCurrentMonthList(true);
    setShowNextMonthList(false);
  };
  const openNextMonthList = () => {
    setShowNextMonthList(true);
    setShowCurrentMonthList(false);
  };

  const closeMonthList = () => {
    setShowCurrentMonthList(false);
    setShowNextMonthList(false);
  };

  /*const handleWayChange = () => {
    if (setTicketSearchPayload) {
      setTicketSearchPayload((prevPayload) => ({
        ...prevPayload,
        isOneWay: !prevPayload.isOneWay,
        backDate: '',
      }));
    }
  };*/

  const handleChangeMonth = (increment: number) => {
    let newMonth = selectedMonth + increment;
    let newYear = selectedYear;

    if (newMonth < 0) {
      newMonth = 11;
      newYear -= 1;
    } else if (newMonth > 11) {
      newMonth = 0;
      newYear += 1;
    }

    const nextMonth = newMonth === 11 ? 0 : newMonth + 1;
    const nextYear = newMonth === 11 ? newYear + 1 : newYear;

    setSelectedYear(newYear);
    setSelectedMonth(newMonth);
    setNextYear(nextYear);
    setNextMonth(nextMonth);
  };

  const renderMonthDropdown = () => {
    return (
      <div className="d-flex-row hovered">
        <div
          className={classNames(
            'd-flex-start-center bb-dashed-gray-1 mr-0_75rem pb-0_25rem p-relative',
            classes.monthContainer
          )}
        >
          <span className="ff-arial fw-600 fs-1_25rem">
            {monthsList[selectedMonth]}{' '}
            {moment().year(selectedYear).format('YYYY')}
          </span>
        </div>
        {!isMobile && <TriangleDownIcon />}
      </div>
    );
  };

  return (
    <div
      className={classNames(
        'd-flex-start-start b-radius-1_5rem p-2_5rem-1_5rem w-100 bg-white',
        classes.Calendar
      )}
    >
      <div className="d-flex-start-between-row w-100">
        <div
          className={classNames(
            'd-flex-start-start w-100 p-relative',
            classes.calendarRow
          )}
        >
          <div
            className={classNames(
              'd-flex-center w-100 mb-2_5rem',
              classes.monthHeader
            )}
          >
            {isMobile && (
              <button
                type="button"
                className={classNames(classes.monthButton, {
                  [classes.disabled]:
                    selectedYear === currentYear &&
                    selectedMonth === currentMonth,
                })}
                onClick={() => handleChangeMonth(-1)}
              >
                {selectedYear === currentYear &&
                selectedMonth === currentMonth ? (
                  <ChevronDisabledIcon />
                ) : (
                  <ChevronActiveIcon />
                )}
              </button>
            )}
            {!isMobile && (
              <button
                className="btn-icon p-absolute left-0"
                onClick={() => handleChangeMonth(-1)}
                /*disabled={
                  selectedYear === currentYear && selectedMonth === currentMonth
                }*/
              >
                <BackArrowSmallIcon className="w-1_5rem h-1_5rem" />
              </button>
            )}
            <div className="d-flex-row hovered" onClick={openCurrentMonthList}>
              {renderMonthDropdown()}
            </div>
            {!isMobile && (
              <button className="btn-icon p-absolute right-0">
                <ForwardArrowSmallIcon
                  className="w-1_5rem h-1_5rem"
                  onClick={() => handleChangeMonth(1)}
                />
              </button>
            )}
            {isMobile && (
              <button
                type="button"
                className={classes.monthButton}
                onClick={() => handleChangeMonth(+1)}
              >
                <ChevronActiveIcon />
              </button>
            )}
          </div>
          {showCurrentMonthList ? (
            <MonthList
              year={selectedYear}
              setCurrentYear={setSelectedYear}
              month={selectedMonth}
              setCurrentMonth={setSelectedMonth}
              setNextYear={setNextYear}
              setNextMonth={setNextMonth}
              closeMonthList={closeMonthList}
              isCurrentMonth={true}
            />
          ) : (
            <CalendarItem
              year={selectedYear}
              month={selectedMonth}
              isLoading={isCurrentMonthLoading}
              minimalPrices={[]}
              calendlyEventsData={calendlyEventsData}
            />
          )}
        </div>
        {/*!isMobile && (
          <div className="d-flex-start-start w-50 pl-1_5rem p-relative">
            <div className="d-flex-center w-100  mb-2_25rem">
              <div className="d-flex-row hovered" onClick={openNextMonthList}>
                {renderNextMonthDropdown()}
              </div>
              <button className="btn-icon p-absolute right-0">
                <ForwardArrowSmallIcon onClick={() => handleChangeMonth(1)} />
              </button>
            </div>
            {showNextMonthList ? (
              <MonthList
                year={selectedMonth === 11 ? selectedYear + 1 : selectedYear}
                setCurrentYear={setSelectedYear}
                month={selectedMonth === 11 ? 0 : selectedMonth + 1}
                setCurrentMonth={setSelectedMonth}
                setNextYear={setNextYear}
                setNextMonth={setNextMonth}
                closeMonthList={closeMonthList}
                isCurrentMonth={false}
              />
            ) : (
              <CalendarItem
                year={nextYear}
                month={nextMonth}
                isLoading={isNextMonthLoading}
                minimalPrices={[]}
              />
            )}
          </div>
        )*/}
      </div>
    </div>
  );
};

export default Calendar;
